import React, { memo } from 'react';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'components/DatePicker';
import { StyledDatePickerWrapper } from './styles';

interface MultiDatePickerProps {
  selectedDates: Dayjs[];
  isOpen: boolean;
  dateRender: (date: Dayjs) => JSX.Element;
  footerRender: () => JSX.Element;
  setIsOpen: (isOpen: boolean) => void;
  onSelectNotWorkedDates: (notWorkedDates: Dayjs[]) => void;
}

const MultiDatePicker: React.FC<MultiDatePickerProps> = ({
  onSelectNotWorkedDates: onMultiDatePickerChange,
  selectedDates,
  isOpen,
  setIsOpen,
  dateRender,
  footerRender,
}) => {
  const toggleDateHandler = (date: Dayjs) => {
    const exists = selectedDates.some((d) => d.isSame(date, 'day'));
    const newDates = exists ? selectedDates.filter((d) => !d.isSame(date, 'day')) : [...selectedDates, date];
    onMultiDatePickerChange(newDates);
  };
  const { t } = useTranslation();
  return (
    <StyledDatePickerWrapper>
      <DatePicker
        placeholder={t('filter.selectNotWorked')}
        value={selectedDates[selectedDates.length - 1] || null}
        open={isOpen}
        onOpenChange={() => setIsOpen(true)}
        picker={isOpen ? 'date' : 'month'}
        onSelect={toggleDateHandler}
        showToday={false}
        dateRender={dateRender}
        renderExtraFooter={footerRender}
      />
    </StyledDatePickerWrapper>
  );
};

export default memo(MultiDatePicker);
